import axios from 'axios'
import campaign from './services/campaign.js'
import badge from './services/badge.js'
import event from './services/event.js'
import challenge from './services/challenge.js'
import activity from './services/activity.js'
import customer from './services/customer.js'
import bubble from './services/bubble.js'
import library from './services/library.js'
import media from './services/media.js'
import contest from './services/contest.js'
import round from './services/round.js'
import kpi from './services/kpi.js'
import advice from './services/advice.js'
import monster from './services/monster.js'
import wave from './services/wave.js'
import banner from './services/banner.js'

const fcts = {
  axios: axios,
  campaign: campaign,
  badge: badge,
  event: event,
  challenge: challenge,
  activity: activity,
  customer: customer,
  bubble: bubble,
  library: library,
  media: media,
  contest: contest,
  round: round,
  kpi: kpi,
  advice: advice,
  monster: monster,
  wave: wave,
  banner: banner,
  
  setInstance: (sitekey) => {
    axios.defaults.headers.common['X-Instance'] = sitekey
    return fcts
  },
  setToken: (token) => {
    axios.defaults.headers.common['X-Token'] = token
    return fcts
  }
}
export default fcts



//////////////////
// WEBPACK FOOTER
// ./node_modules/@rocketfid/api/index.js
// module id = null
// module chunks = 